import React from "react";
import * as Icons from "lucide-react";
import { SERVICES, SURGICAL, T, waLink } from "../../data/content";
import { useLang } from "../../context/i18n";
import { Reveal } from "./Motion";
import { track } from "./Chrome";
import { CONFIG } from "../../data/content";

const spans = ["lg:col-span-2", "", "", "", "lg:col-span-2", "", "", "", ""];

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <Reveal>
          <p className="font-head text-sm font-bold uppercase tracking-widest text-[var(--red)]">01 — {t(T.servicesTitle)}</p>
          <h2 className="mt-3 max-w-2xl font-head text-3xl font-extrabold tracking-tight text-[var(--navy)] sm:text-4xl lg:text-5xl">{t(T.servicesTitle)}</h2>
          <p className="mt-4 max-w-2xl text-base text-[var(--slate)] md:text-lg">{t(T.servicesSub)}</p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Ico = Icons[s.icon] || Icons.Plus;
            return (
              <Reveal key={i} delay={i * 0.05} className={spans[i]}>
                <div data-testid={`service-card-${i}`}
                     className="group h-full rounded-3xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[var(--navy)] hover:shadow-lg">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[var(--bg-soft)] text-[var(--navy)] transition-colors group-hover:bg-[var(--navy)] group-hover:text-white">
                    <Ico size={22} />
                  </div>
                  <h3 className="mt-5 font-head text-xl font-bold tracking-tight text-[var(--navy)]">{t(s).t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[var(--slate)]">{t(s).d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>

      {/* Surgical services */}
      <div className="mt-20 border-y border-slate-200 bg-[var(--navy)] py-16 text-white">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
            <div>
              <p className="font-head text-sm font-bold uppercase tracking-widest text-[var(--red)]">02 — {t(T.surgicalTitle)}</p>
              <h2 className="mt-3 font-head text-3xl font-extrabold tracking-tight sm:text-4xl">{t(T.surgicalTitle)}</h2>
            </div>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" onClick={() => track("consult_surgeon")} data-testid="consult-surgeon-btn"
               className="inline-flex items-center gap-2 rounded-full bg-[var(--green)] px-6 py-3.5 text-sm font-bold text-white transition-all hover:scale-[1.03] hover:bg-[var(--green-hover)]">
              <i className="fa-brands fa-whatsapp text-lg" aria-hidden="true"></i> {t(T.consultSurgeon)}
            </a>
          </div>
        </div>
        <div className="relative mt-10 overflow-hidden">
          <div className="marquee-track">
            {[0, 1].map((dup) => (
              <div key={dup} className="flex" aria-hidden={dup === 1}>
                {SURGICAL.map((it, i) => (
                  <span key={i} className="mx-4 inline-flex items-center gap-3 font-head text-2xl font-bold tracking-tight text-white/90 sm:text-3xl">
                    {t(it)} <span className="text-[var(--green)]">✦</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="mx-auto mt-10 max-w-7xl px-4 lg:px-8">
          <img src={CONFIG.images.surgery} alt="Jan Seva Hospital surgical team performing a procedure" loading="lazy"
               className="w-full rounded-3xl object-cover opacity-95 ring-1 ring-white/10" />
        </div>
      </div>
    </section>
  );
};
